/**
 * <Transition />
 *
 * This is a wrapper component for ReactCSSTransitionGroup.
 *
 * @parent anybody
 * @children anybody
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './fade.scss';
import './fade-delayed.scss';
import './expand.scss';
import './expand-down.scss';
import './slide-down.scss';
import './slide.scss';

const DEFAULT_TYPE = 'fade';

class Transition extends React.Component {
  static propTypes = {
    type: PropTypes.string,
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    let {
      type
    } = this.props;
    return (
      <ReactCSSTransitionGroup
        transitionName={type || DEFAULT_TYPE}
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}>
        {this.props.children}
      </ReactCSSTransitionGroup>
    )
  }
}

export default Transition;



// WEBPACK FOOTER //
// ./src/components/UI/Transition/index.js